import { render, staticRenderFns } from "./MirrorSidebar.vue?vue&type=template&id=ae32b642&scoped=true&"
import script from "./MirrorSidebar.vue?vue&type=script&lang=js&"
export * from "./MirrorSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MirrorSidebar.vue?vue&type=style&index=0&id=ae32b642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae32b642",
  null
  
)

export default component.exports